export default __webpack_public_path__ + "static/media/eye-closed.a9f20b0a.svg";